var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container pt-4"},[_c('div',{staticClass:"page-form-row row"},[_c('div',{staticClass:"card main-card"},[_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.$store.getters.getLogo || '../assets/logo_tmp.png'}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.submitResult.Message)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }